import { Component } from '@angular/core';

@Component({
  selector: 'app-departure-date',
  templateUrl: './departure-date.component.html',
  styleUrls: ['./departure-date.component.scss']
})
export class DepartureDateComponent {

}
